module.exports = __webpack_public_path__ + "static/media/squared.0a1aa2df.jpg";